module.exports = __webpack_public_path__ + "img/student-brief (3).548a2402.png";